const Returns = () => {
  return (
    <div>
      <h3>Возвраты</h3>
      <p>Информация по возвратам товаров.</p>
    </div>
  );
};

export default Returns;
